import { Outlet } from "react-router-dom";
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
const Layout = () => {
    return (
        <>
            <CssBaseline />
            <Container fixed>
                <Box sx={{ bgcolor: '#cfe8fc', padding:'40px' }}>
                    <Outlet />
                </Box>
            </Container>
        </>
    )
};
export default Layout;
